import {JsonView} from './shared'

interface RequestTabProps {
    record: any
}

function RequestTab({record}: RequestTabProps) {
    return (
        <JsonView
            data={record?.data.originalEvent}
            placeholder="No request data"
        />
    )
}

export default RequestTab
